import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
const initialState = {
  generalFilter: {
    edps: null,
    homologations:null,
    stations:null,
    semaphore:null
  },
};
export const AlertContext = React.createContext([]);
export const AlertContextProvider = ({ children }) => {
  const [fullContent, setFullContent] = useState(true);
  const [ismobile, setismobile] = useState(false);
  const [generalFilter, setgeneralFilter] = useState(
    initialState.generalFilter
  );
  //functions
  const showErrors = (errors) => {
    Swal.fire({
      icon: "warning",
      html: getError(errors),
    });
  };

  const getError = (errors) => {
    let keys = Object.keys(errors);
    let li = "";

    for (let i = 0; i < keys.length; i++) {
      li = li + "<li>" + eval("errors." + keys[i]) + "</li>";
    }
    return li;
  };
  const alertSuccess = (text) => {
    const Toast = Swal.mixin({
      toast: true,
      background: "#ffffff",
      position: "bottom-end",
      showConfirmButton: false,
      timer: 4000,
    });

    Toast.fire({
      icon: "success",
      title: text,
    });
  };
  const alertInfo = (text,withTime=true) => {
    const Toast = Swal.mixin({
      toast: true,
      background: "#ffffff",
      position: "bottom-end",
      showConfirmButton: false,
      timer: withTime?4000:0,
    });

    Toast.fire({
      icon: "info",
      title: text,
    });
  };
  const alertWarning = (text) => {
    const Toast = Swal.mixin({
      toast: true,
      background: "#e4e4e4",
      position: "bottom-end",
      showConfirmButton: false,
      timer: 4000,
    });

    Toast.fire({
      icon: "warning",
      title: text,
    });
  };
  const alertError = (text) => {
    const Toast = Swal.mixin({
      toast: true,
      background: "#e4e4e4",
      position: "bottom-end",
      showConfirmButton: false,
      timer: 4000,
    });

    Toast.fire({
      icon: "error",
      title: text,
    });
  };

  return (
    <AlertContext.Provider
      value={[
        { fullContent, ismobile,generalFilter },
        {
          alertInfo,
          alertSuccess,
          alertWarning,
          alertError,
          showErrors,
          setFullContent,
          setismobile,
          setgeneralFilter
          
        },
      ]}
    >
      {children}
    </AlertContext.Provider>
  );
};
